import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation } from "swiper";
import { useSelector } from "react-redux/es/exports";

function SectionTwelveBannerThemeThree() {
  const homedata: any = useSelector<any>((state) => state?.homeJsonList);
  const section = homedata?.theme_3?.home?.section_12;
  

  const renderStars = (rating: string) => {
    const count = parseInt(rating, 10) || 5;
    return Array.from({ length: 5 }, (_, i) => (
      <i
        key={i}
        className={`fas fa-star${i < count ? "" : " t3testi-star-empty"}`}
      />
    ));
  };

  return (
    <section className="t3testi-wrap">
      <div className="t3testi-shell">
        <div className="t3testi-header">
          {section?.sub_heading_top && (
            <span className="t3testi-tag">{section.sub_heading_top}</span>
          )}
          <h2
            className="t3testi-title"
            style={section?.h2color ? { color: `#${section.h2color}` } : {}}
          >
            {section?.title}
          </h2>
          <p
            className="t3testi-sub"
            style={section?.paracolor ? { color: `#${section.paracolor}` } : {}}
          >
            {section?.paragraph}
          </p>
        </div>

        <Swiper
          spaceBetween={20}
          navigation={true}
          modules={[Navigation]}
          breakpoints={{
            0: { slidesPerView: 1 },
            640: { slidesPerView: 1 },
            768: { slidesPerView: 2 },
            1024: { slidesPerView: 3 },
          }}
          className="t3testi-slider"
        >
          {section?.review_card?.map((item: any) => (
            <SwiperSlide key={item._id}>
              <div className="t3testi-card">
                <div className="t3testi-top">
                  <div className="t3testi-avatar">
                    <img
                      src={item.reviewer_pic}
                      alt={item.reviewer_name}
                      className="rounded-circle"
                    />
                  </div>
                  <div className="t3testi-user">
                    <h6
                      className="t3testi-name"
                      style={
                        section?.h3color ? { color: `#${section.h3color}` } : {}
                      }
                    >
                      {item.reviewer_name}
                    </h6>
                    <div className="t3testi-stars">
                      {renderStars(item.rating)}
                      <span className="t3testi-rating-num">{item.rating}</span>
                    </div>
                  </div>
                </div>
                <h5
                  className="t3testi-highlight"
                  style={
                    section?.h3color ? { color: `#${section.h3color}` } : {}
                  }
                >
                  {item.review_highlight}
                </h5>
                <p
                  className="t3testi-review"
                  style={
                    section?.paracolor ? { color: `#${section.paracolor}` } : {}
                  }
                >
                  {item.review}
                </p>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </section>
  );
}

export default SectionTwelveBannerThemeThree;
